import { render, staticRenderFns } from "./overlay-root.vue?vue&type=template&id=6204de20&"
import script from "./overlay-root.vue?vue&type=script&lang=js&"
export * from "./overlay-root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports